module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "oco--dataset-cover.f964f42b.jpg";